<template>
  <form>
    <div class="row">
      <div class="col-12">
        <div class="form-group mb-0">
          <item-storage-select v-model="episode.storage" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <basic-portlet :no-shadow="true"
                       :no-gutters="true"
                       portlet-classes="mb-0">
          <general-settings />
        </basic-portlet>
        <basic-portlet title="Publish Settings"
                       :no-shadow="true"
                       :no-gutters="true"
                       portlet-classes="mb-0">
          <publish-settings />
        </basic-portlet>
        <basic-portlet title="Advanced Settings"
                       :no-shadow="true"
                       :no-gutters="true"
                       portlet-classes="mb-0"
                       portlet-body-classes="pb-0">
          <advanced-settings />
        </basic-portlet>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12  no-gutters">
        <hr>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-ss"
                type="button"
                :disabled="!episode.storage || saving"
                @click="validateAndSave($validator)">
          <b-spinner v-if="saving" small label="Saving..." />Create {{ getItemLabel(true) }}
        </button>
        <button class="btn btn-ss-standout"
                type="button"
                :disabled="!episode.storage || saving"
                @click="validateAndSave($validator, false, true)">
          <b-spinner v-if="saving" small label="Saving..." />Create & View {{ getItemLabel(true) }}
        </button>
      </div>
    </div>
  </form>
</template>
<script>

import { mapWritableState, mapActions } from 'pinia';
import { useEpisodeManageStore } from "VueStore/app/episodeManage";
import GeneralSettings from "VuePartials/Items/EpisodeSettings/General";
import PublishSettings from "VuePartials/Items/EpisodeSettings/Publishing";
import AdvancedSettings from "VuePartials/Items/EpisodeSettings/Advanced";
import ItemStorageSelect from "VueComponents/ItemCreation/ItemStorageSelect";
import VeeValidate from "vee-validate";
Vue.use(VeeValidate, { inject: false, useConstraintAttrs: false });
VeeValidate.config.fieldsBagName = "veeFields";

export default {
  components: {
    ItemStorageSelect,
    GeneralSettings,
    PublishSettings,
    AdvancedSettings,
  },
  /**
   * In order to validate forms inside child components we need to provide the parent instance of validator
   * Each component that needs validating will need to include the PodcastValidateMixin which references this parent
   * via injection.
   * @returns {*}
   */
  provide() {
    return { parentValidator: this.$validator };
  },
  props: {
    preselectedStorageAsset: {
      type: Object,
      required: false,
      default: null,
    },
    preselectedFeed: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapWritableState(useEpisodeManageStore, ['episode']),
    ...mapWritableState(useEpisodeManageStore, ['saving']),
  },
  beforeMount() {
    if (this.preselectedStorageAsset) {
      this.setStorageAsset(this.preselectedStorageAsset);
    }

    if (this.preselectedFeed) {
      this.setPodcast(this.preselectedFeed);
      this.setArtwork(this.preselectedFeed.artwork);
    }

    this.setEpisodeExplicitOption();
    this.setTypeOption();
  },
  mounted() {
    this.getAllTags();
  },
  methods: {
    ...mapActions(useEpisodeManageStore, ['setArtwork']),
    ...mapActions(useEpisodeManageStore, ['setStorage']),
    ...mapActions(useEpisodeManageStore, ['setPodcast']),
    ...mapActions(useEpisodeManageStore, ['setEpisodeExplicitOption']),
    ...mapActions(useEpisodeManageStore, ['setTypeOption']),
    ...mapActions(useEpisodeManageStore, ['getAllTags']),
    ...mapActions(useEpisodeManageStore, ['validateAndSave']),
  },
};
</script>
